var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMachineBelt1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 755 356.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-17,.cls-22,.cls-29,.cls-36,.cls-37{fill:none;}.cls-2{fill:#fff;}.cls-3{fill:#c8cad1;}.cls-4{fill:#d9e6ed;}.cls-5{fill:#acc6d1;}.cls-6{opacity:0.4;}.cls-7{fill:#9aa4ae;}.cls-8{fill:#b8bcc1;}.cls-9{fill:#495d66;}.cls-10{fill:#86939c;}.cls-11{fill:#8d9aa0;}.cls-12{fill:#7c878c;}.cls-13{fill:#343f42;}.cls-14{fill:#2a3335;}.cls-15{fill:#b8bdc1;}.cls-16{fill:#9aa3ae;}.cls-17{stroke:#86939c;}.cls-17,.cls-22,.cls-23,.cls-29,.cls-36,.cls-37{stroke-miterlimit:10;}.cls-18{fill:#303b3e;}.cls-19{fill:#f44d4d;}.cls-20{fill:#f66562;}.cls-21{fill:#d0d6e2;}.cls-22,.cls-23{stroke:#343f42;}.cls-23{fill:#d0d6e0;}.Graphic-Style-2,.cls-27{fill:#8ab3ff;}.Graphic-Style-2{opacity:0.5;mix-blend-mode:screen;}.cls-24{fill:#ccd6e5;}.cls-25{fill:#b8bcc0;}.cls-26{fill:#9caab2;}.cls-28{fill:#588df0;}.cls-29{stroke:#588df0;}.cls-30{fill:#cbd5e4;}.cls-31{fill:#b9bdc1;}.cls-32{fill:#1a3447;}.cls-33{fill:#6c8197;}.cls-34{fill:#dadada;}.cls-35{clip-path:url(#clip-path);}.cls-36{stroke:#fff;}.cls-37{stroke:#bdbdbd;stroke-width:2px;}.cls-38{fill:#bdbdbd;}.cls-39{fill:#960002;}.cls-40{fill:#ff031c;}.cls-41{fill:#b97109;}.cls-42{fill:#ff9c0e;}.cls-43{fill:#02782c;}.cls-44{fill:#00de42;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10,2.17C9.88,1.49,9.13.82,7.77.4,5.48-.3,2.38-.06.85,1A1.52,1.52,0,0,0,0,2.17H0v0H0L0,76.85c.08.68.83,1.34,2.19,1.76,2.28.71,5.38.46,6.92-.55A1.57,1.57,0,0,0,10,76.85h0v0h0V2.17Z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "Jar_01b",
    "data-name": "Jar_01b",
    viewBox: "0 0 9.26 18.96"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M9.26,4.77h0c0-.65-.75-1.28-2-1.68a8.8,8.8,0,0,0-6.42.5A1.41,1.41,0,0,0,0,4.77H0V16.91H0c0,.65.75,1.28,2.05,1.68a8.8,8.8,0,0,0,6.42-.5,1.41,1.41,0,0,0,.79-1.18h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M8.33,1.64h0c0-.52-.59-1-1.63-1.34A7,7,0,0,0,1.56.7a1.08,1.08,0,0,0-.63.94h0v2h0c0,.51.59,1,1.63,1.34a7,7,0,0,0,5.14-.4,1.1,1.1,0,0,0,.63-.94h0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 4.63,
    cy: 1.82,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(2.76 6.43) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M9.26,4.77a.24.24,0,0,0,0-.09,1.32,1.32,0,0,1-.76,1.26c-1.42.93-4.3,1.15-6.42.5C.74,6,0,5.41,0,4.76H0V16.91H0c0,.65.75,1.28,2.05,1.68a8.8,8.8,0,0,0,6.42-.5,1.41,1.41,0,0,0,.79-1.18h0V4.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2.05,6.44c-1.3-.4-2-1-2-1.67H0V16.91H0c0,.65.75,1.28,2.05,1.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M8.31,1.56A1.37,1.37,0,0,1,7.43,3a7.21,7.21,0,0,1-5.21.19C1.15,2.8.9,2.1.94,1.55c0,0,0,.06,0,.09h0v2c0,.51.59,1,1.63,1.34a7,7,0,0,0,5.14-.4,1.1,1.1,0,0,0,.63-.94h0v-2h0S8.31,1.59,8.31,1.56Z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "Jars_06",
    "data-name": "Jars_06",
    viewBox: "0 0 575.34 172.48"
  }, /*#__PURE__*/React.createElement("use", {
    width: 9.26,
    height: 18.96,
    transform: "translate(0 142.48)",
    xlinkHref: "#Jar_01b"
  }), /*#__PURE__*/React.createElement("use", {
    width: 9.26,
    height: 18.96,
    transform: "translate(19.15 153.52)",
    xlinkHref: "#Jar_01b"
  }), /*#__PURE__*/React.createElement("use", {
    width: 9.26,
    height: 18.96,
    transform: "translate(26.71 133.57)",
    xlinkHref: "#Jar_01b"
  }), /*#__PURE__*/React.createElement("use", {
    width: 9.26,
    height: 18.96,
    transform: "translate(45.86 144.62)",
    xlinkHref: "#Jar_01b"
  }), /*#__PURE__*/React.createElement("use", {
    width: 9.26,
    height: 18.96,
    transform: "translate(53.43 124.67)",
    xlinkHref: "#Jar_01b"
  }), /*#__PURE__*/React.createElement("use", {
    width: 9.26,
    height: 18.96,
    transform: "translate(72.57 135.71)",
    xlinkHref: "#Jar_01b"
  }), /*#__PURE__*/React.createElement("use", {
    width: 9.26,
    height: 18.96,
    transform: "translate(80.14 115.76)",
    xlinkHref: "#Jar_01b"
  }), /*#__PURE__*/React.createElement("use", {
    width: 9.26,
    height: 18.96,
    transform: "translate(99.29 126.81)",
    xlinkHref: "#Jar_01b"
  }), /*#__PURE__*/React.createElement("use", {
    width: 9.26,
    height: 18.96,
    transform: "translate(106.86 106.86)",
    xlinkHref: "#Jar_01b"
  }), /*#__PURE__*/React.createElement("use", {
    width: 9.26,
    height: 18.96,
    transform: "translate(126 117.9)",
    xlinkHref: "#Jar_01b"
  }), /*#__PURE__*/React.createElement("use", {
    width: 9.26,
    height: 18.96,
    transform: "translate(133.57 97.95)",
    xlinkHref: "#Jar_01b"
  }), /*#__PURE__*/React.createElement("use", {
    width: 9.26,
    height: 18.96,
    transform: "translate(152.72 109)",
    xlinkHref: "#Jar_01b"
  }), /*#__PURE__*/React.createElement("use", {
    width: 9.26,
    height: 18.96,
    transform: "translate(160.28 89.05)",
    xlinkHref: "#Jar_01b"
  }), /*#__PURE__*/React.createElement("use", {
    width: 9.26,
    height: 18.96,
    transform: "translate(179.43 100.09)",
    xlinkHref: "#Jar_01b"
  }), /*#__PURE__*/React.createElement("use", {
    width: 9.26,
    height: 18.96,
    transform: "translate(187 80.14)",
    xlinkHref: "#Jar_01b"
  }), /*#__PURE__*/React.createElement("use", {
    width: 9.26,
    height: 18.96,
    transform: "translate(206.14 91.19)",
    xlinkHref: "#Jar_01b"
  }), /*#__PURE__*/React.createElement("use", {
    width: 9.26,
    height: 18.96,
    transform: "translate(213.71 71.24)",
    xlinkHref: "#Jar_01b"
  }), /*#__PURE__*/React.createElement("use", {
    width: 9.26,
    height: 18.96,
    transform: "translate(232.86 82.29)",
    xlinkHref: "#Jar_01b"
  }), /*#__PURE__*/React.createElement("use", {
    width: 9.26,
    height: 18.96,
    transform: "translate(240.43 62.33)",
    xlinkHref: "#Jar_01b"
  }), /*#__PURE__*/React.createElement("use", {
    width: 9.26,
    height: 18.96,
    transform: "translate(259.57 73.38)",
    xlinkHref: "#Jar_01b"
  }), /*#__PURE__*/React.createElement("use", {
    width: 9.26,
    height: 18.96,
    transform: "translate(267.14 53.43)",
    xlinkHref: "#Jar_01b"
  }), /*#__PURE__*/React.createElement("use", {
    width: 9.26,
    height: 18.96,
    transform: "translate(286.29 64.48)",
    xlinkHref: "#Jar_01b"
  }), /*#__PURE__*/React.createElement("use", {
    width: 9.26,
    height: 18.96,
    transform: "translate(293.86 44.52)",
    xlinkHref: "#Jar_01b"
  }), /*#__PURE__*/React.createElement("use", {
    width: 9.26,
    height: 18.96,
    transform: "translate(313 55.57)",
    xlinkHref: "#Jar_01b"
  }), /*#__PURE__*/React.createElement("use", {
    width: 9.26,
    height: 18.96,
    transform: "translate(320.57 35.62)",
    xlinkHref: "#Jar_01b"
  }), /*#__PURE__*/React.createElement("use", {
    width: 9.26,
    height: 18.96,
    transform: "translate(339.71 46.67)",
    xlinkHref: "#Jar_01b"
  }), /*#__PURE__*/React.createElement("use", {
    width: 9.26,
    height: 18.96,
    transform: "translate(347.28 26.71)",
    xlinkHref: "#Jar_01b"
  }), /*#__PURE__*/React.createElement("use", {
    width: 9.26,
    height: 18.96,
    transform: "translate(366.43 37.76)",
    xlinkHref: "#Jar_01b"
  }), /*#__PURE__*/React.createElement("use", {
    width: 9.26,
    height: 18.96,
    transform: "translate(374 17.81)",
    xlinkHref: "#Jar_01b"
  }), /*#__PURE__*/React.createElement("use", {
    width: 9.26,
    height: 18.96,
    transform: "translate(393.14 28.86)",
    xlinkHref: "#Jar_01b"
  }), /*#__PURE__*/React.createElement("use", {
    width: 9.26,
    height: 18.96,
    transform: "translate(400.71 8.9)",
    xlinkHref: "#Jar_01b"
  }), /*#__PURE__*/React.createElement("use", {
    width: 9.26,
    height: 18.96,
    transform: "translate(419.86 19.95)",
    xlinkHref: "#Jar_01b"
  }), /*#__PURE__*/React.createElement("use", {
    width: 9.26,
    height: 18.96,
    transform: "translate(427.43)",
    xlinkHref: "#Jar_01b"
  }), /*#__PURE__*/React.createElement("use", {
    width: 9.26,
    height: 18.96,
    transform: "translate(446.57 11.05)",
    xlinkHref: "#Jar_01b"
  }), /*#__PURE__*/React.createElement("use", {
    width: 9.26,
    height: 18.96,
    transform: "translate(440.55 29.99)",
    xlinkHref: "#Jar_01b"
  }), /*#__PURE__*/React.createElement("use", {
    width: 9.26,
    height: 18.96,
    transform: "translate(459.69 41.04)",
    xlinkHref: "#Jar_01b"
  }), /*#__PURE__*/React.createElement("use", {
    width: 9.26,
    height: 18.96,
    transform: "translate(467.26 21.09)",
    xlinkHref: "#Jar_01b"
  }), /*#__PURE__*/React.createElement("use", {
    width: 9.26,
    height: 18.96,
    transform: "translate(486.41 32.14)",
    xlinkHref: "#Jar_01b"
  }), /*#__PURE__*/React.createElement("use", {
    width: 9.26,
    height: 18.96,
    transform: "translate(480.39 51.08)",
    xlinkHref: "#Jar_01b"
  }), /*#__PURE__*/React.createElement("use", {
    width: 9.26,
    height: 18.96,
    transform: "translate(499.53 62.13)",
    xlinkHref: "#Jar_01b"
  }), /*#__PURE__*/React.createElement("use", {
    width: 9.26,
    height: 18.96,
    transform: "translate(507.1 42.18)",
    xlinkHref: "#Jar_01b"
  }), /*#__PURE__*/React.createElement("use", {
    width: 9.26,
    height: 18.96,
    transform: "translate(526.25 53.23)",
    xlinkHref: "#Jar_01b"
  }), /*#__PURE__*/React.createElement("use", {
    width: 9.26,
    height: 18.96,
    transform: "translate(520.22 72.18)",
    xlinkHref: "#Jar_01b"
  }), /*#__PURE__*/React.createElement("use", {
    width: 9.26,
    height: 18.96,
    transform: "translate(539.37 83.22)",
    xlinkHref: "#Jar_01b"
  }), /*#__PURE__*/React.createElement("use", {
    width: 9.26,
    height: 18.96,
    transform: "translate(546.94 63.27)",
    xlinkHref: "#Jar_01b"
  }), /*#__PURE__*/React.createElement("use", {
    width: 9.26,
    height: 18.96,
    transform: "translate(566.08 74.32)",
    xlinkHref: "#Jar_01b"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "WarningLightOff_01",
    "data-name": "WarningLightOff_01",
    viewBox: "0 0 9.97 79.77"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M10,2.17C9.88,1.49,9.13.82,7.77.4,5.48-.3,2.38-.06.85,1A1.52,1.52,0,0,0,0,2.17H0v0H0L0,76.85c.08.68.83,1.34,2.19,1.76,2.28.71,5.38.46,6.92-.55A1.57,1.57,0,0,0,10,76.85h0v0h0V2.17Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-35"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-36",
    x1: 1.65,
    y1: 2.49,
    x2: 1.65,
    y2: 79.77
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-37",
    x1: 7.28,
    y1: 2.49,
    x2: 7.28,
    y2: 79.77
  })), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-38",
    cx: 4.99,
    cy: 2.22,
    rx: 2.2,
    ry: 4.99,
    transform: "translate(2.72 7.18) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M10,4.22a1.47,1.47,0,0,1-.83,1.32c-1.54,1-4.64,1.24-6.92.54C.78,5.64,0,5,0,4.25L0,13.5c.07.67.82,1.34,2.18,1.76,2.29.7,5.38.46,6.92-.55A1.57,1.57,0,0,0,10,13.5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 3.38,
    y: 7.97,
    width: 3.16,
    height: 5.42
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M10,13.39a1.47,1.47,0,0,1-.83,1.32c-1.54,1-4.63,1.24-6.92.54C.78,14.81,0,14.13,0,13.42l0,9.25c.07.68.82,1.34,2.18,1.76,2.29.71,5.38.46,6.92-.55A1.52,1.52,0,0,0,10,22.67Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 3.38,
    y: 17.15,
    width: 3.16,
    height: 5.42
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M10,22.57a1.46,1.46,0,0,1-.83,1.31c-1.54,1-4.63,1.24-6.92.54C.78,24,0,23.3,0,22.59l0,9.25c.07.68.82,1.34,2.18,1.76,2.29.71,5.38.46,6.92-.54A1.54,1.54,0,0,0,10,31.84Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 3.38,
    y: 26.21,
    width: 3.16,
    height: 5.42
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "Screen_01b",
    "data-name": "Screen_01b",
    viewBox: "0 0 56.52 74.04"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "6.65 20.04 56.52 3.84 49.87 0 0 16.2 6.65 20.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "0 70.2 0 16.2 6.65 20.04 6.65 74.04 0 70.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "56.52 3.84 6.65 20.04 6.65 74.04 56.52 57.84 56.52 3.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "53.27 11.01 9.97 24.96 9.97 60.96 53.2 46.92 53.27 11.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "49.87 15 13.3 26.88 13.3 56.88 49.87 45 49.87 15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "16.63 28.8 16.63 52.8 29.93 48.48 29.93 24.48 16.63 28.8"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-29",
    x1: 46.55,
    y1: 22.08,
    x2: 33.25,
    y2: 26.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-29",
    x1: 46.55,
    y1: 28.08,
    x2: 33.25,
    y2: 32.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-29",
    x1: 46.55,
    y1: 34.08,
    x2: 33.25,
    y2: 38.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-29",
    x1: 46.55,
    y1: 40.08,
    x2: 33.25,
    y2: 44.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M48.32,57.73a2.8,2.8,0,0,0,1.67,0,4.17,4.17,0,0,0,2.77-3.86,3.33,3.33,0,0,0-2.25-3.23,2.8,2.8,0,0,0-1.67,0,4.17,4.17,0,0,0-2.77,3.86A3.3,3.3,0,0,0,48.32,57.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M47.24,54.86a3.3,3.3,0,0,1,2.18-3,1.71,1.71,0,0,1,1.49.16h0l0,0,3.18,2h0a1.68,1.68,0,0,1,.68,1.45,3.32,3.32,0,0,1-2.18,3,1.71,1.71,0,0,1-1.47-.16l-3.23-2.07A1.66,1.66,0,0,1,47.24,54.86Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-20",
    cx: 52.65,
    cy: 56.25,
    rx: 2.6,
    ry: 1.91,
    transform: "translate(-23.78 65.92) rotate(-54.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M38.6,60.77a2.8,2.8,0,0,0,1.67,0A4.15,4.15,0,0,0,43,56.88a3.29,3.29,0,0,0-2.25-3.22,2.85,2.85,0,0,0-1.66,0,4.15,4.15,0,0,0-2.77,3.87A3.3,3.3,0,0,0,38.6,60.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M37.52,57.89a3.32,3.32,0,0,1,2.18-3,1.68,1.68,0,0,1,1.49.17h0l0,0,3.18,2h0a1.68,1.68,0,0,1,.68,1.44,3.3,3.3,0,0,1-2.18,3,1.71,1.71,0,0,1-1.47-.15l-3.24-2.07A1.7,1.7,0,0,1,37.52,57.89Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-20",
    cx: 42.93,
    cy: 59.28,
    rx: 2.6,
    ry: 1.91,
    transform: "translate(-30.27 59.3) rotate(-54.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M30.5,63A2.55,2.55,0,0,0,32,63a4,4,0,0,0,2.62-3.64,2.89,2.89,0,0,0-2-2.83,2.55,2.55,0,0,0-1.52,0,4,4,0,0,0-2.62,3.64A2.88,2.88,0,0,0,30.5,63Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-21",
    cx: 31.59,
    cy: 59.74,
    rx: 2.6,
    ry: 1.91,
    transform: "translate(-35.32 50.31) rotate(-54.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M22.4,65.52a2.63,2.63,0,0,0,1.52,0,4,4,0,0,0,2.62-3.64,2.9,2.9,0,0,0-2-2.83,2.63,2.63,0,0,0-1.52,0,4,4,0,0,0-2.62,3.64A2.89,2.89,0,0,0,22.4,65.52Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-21",
    cx: 23.49,
    cy: 62.27,
    rx: 2.6,
    ry: 1.91,
    transform: "translate(-40.73 44.79) rotate(-54.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M14.29,68a2.58,2.58,0,0,0,1.53,0,4,4,0,0,0,2.62-3.64,2.9,2.9,0,0,0-2-2.83,2.47,2.47,0,0,0-1.52,0,4,4,0,0,0-2.62,3.63A2.88,2.88,0,0,0,14.29,68Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-21",
    cx: 15.39,
    cy: 64.8,
    rx: 2.6,
    ry: 1.91,
    transform: "translate(-46.13 39.28) rotate(-54.11)"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "Screen_Arm_01b",
    "data-name": "Screen_Arm_01b",
    viewBox: "0 0 83.12 195.84"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "19.95 47.16 39.9 40.68 19.95 29.16 0 35.64 19.95 47.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "59.85 25.2 59.85 127.2 53.2 129.36 53.2 27.36 59.85 25.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "46.55 29.52 46.55 131.52 53.2 129.36 53.2 27.36 46.55 29.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "53.2 15.36 33.25 3.84 26.6 6 46.55 17.52 53.2 15.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "43.22 24.6 19.95 11.16 26.6 6 46.55 17.52 43.22 24.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "26.6 15 26.6 39 19.95 41.16 19.95 11.16 26.6 15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "13.3 7.32 13.3 37.32 19.95 41.16 19.95 11.16 13.3 7.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "46.55 17.52 53.2 27.36 46.55 29.52 43.22 24.6 46.55 17.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "53.2 15.36 59.85 25.2 53.2 27.36 46.55 17.52 53.2 15.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "26.6 6 19.95 11.16 13.3 7.32 19.95 2.16 26.6 6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "33.25 3.84 26.6 6 19.95 2.16 26.6 0 33.25 3.84"
  }), /*#__PURE__*/React.createElement("use", {
    width: 56.52,
    height: 74.04,
    transform: "translate(26.6 121.79)",
    xlinkHref: "#Screen_01b"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "Machine_Belt_01",
    "data-name": "Machine_Belt_01",
    viewBox: "0 0 755 356.28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "New_Symbol_17",
    "data-name": "New Symbol 17"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("image", {
    width: 755,
    height: 268,
    transform: "translate(0 88.28)",
    xlinkHref: "data:image/png;base64,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"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M508.69,112.54,96.4,246.5v36l412.29-134Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "718.16 161.47 528.64 52.05 36.55 211.94 96.4 246.5 508.69 112.54 638.37 187.4 718.16 161.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "704.35 159.51 528.64 58.05 49.85 213.62 96.4 240.5 508.69 106.54 638.37 181.4 704.35 159.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "36.55 211.94 36.55 247.94 96.4 282.5 96.4 246.5 36.55 211.94"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-10",
    points: "508.69 112.54 508.69 148.54 638.37 223.4 638.37 187.4 508.69 112.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "718.16 161.47 718.16 197.38 638.37 223.4 638.37 187.4 718.16 161.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "438.87 171.22 438.87 195.22 432.22 197.38 432.22 173.38 438.87 171.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "425.57 175.54 425.57 193.54 432.22 197.38 432.22 173.38 425.57 175.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "438.87 195.22 438.87 204.22 432.22 206.38 432.22 197.38 438.87 195.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "425.57 193.54 425.57 202.54 432.22 206.38 432.22 197.38 425.57 193.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "352.42 199.31 352.42 223.31 345.77 225.47 345.77 201.47 352.42 199.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "339.12 203.63 339.12 221.63 345.77 225.47 345.77 201.47 339.12 203.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "352.42 223.31 352.42 232.31 345.77 234.47 345.77 225.47 352.42 223.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "339.12 221.63 339.12 230.63 345.77 234.47 345.77 225.47 339.12 221.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "269.3 226.32 269.3 250.32 262.65 252.48 262.65 228.48 269.3 226.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "256 230.64 256 248.64 262.65 252.48 262.65 228.48 256 230.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "269.3 250.32 269.3 259.32 262.65 261.48 262.65 252.48 269.3 250.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "256 248.64 256 257.64 262.65 261.48 262.65 252.48 256 248.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "63.15 263.3 63.15 281.3 56.5 283.46 56.5 259.46 63.15 263.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "49.85 255.62 49.85 279.62 56.5 283.46 56.5 259.46 49.85 255.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "63.15 281.3 63.15 290.3 56.5 292.46 56.5 283.46 63.15 281.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "49.85 279.62 49.85 288.62 56.5 292.46 56.5 283.46 49.85 279.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "103.05 280.34 103.05 304.34 96.4 306.5 96.4 282.5 103.05 280.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "89.75 278.66 89.75 302.66 96.4 306.5 96.4 282.5 89.75 278.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "103.05 304.34 103.05 313.34 96.4 315.5 96.4 306.5 103.05 304.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "89.75 302.66 89.75 311.66 96.4 315.5 96.4 306.5 89.75 302.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "186.17 253.33 186.17 277.33 179.52 279.49 179.52 255.49 186.17 253.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "172.87 257.65 172.87 275.65 179.52 279.49 179.52 255.49 172.87 257.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "186.17 277.33 186.17 286.33 179.52 288.49 179.52 279.49 186.17 277.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "172.87 275.65 172.87 284.65 179.52 288.49 179.52 279.49 172.87 275.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "515.34 152.38 515.34 170.38 508.69 172.54 508.69 148.54 515.34 152.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "502.04 150.7 502.04 168.7 508.69 172.54 508.69 148.54 502.04 150.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "515.34 170.38 515.34 179.38 508.69 181.54 508.69 172.54 515.34 170.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "502.04 168.7 502.04 177.7 508.69 181.54 508.69 172.54 502.04 168.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "578.52 188.85 578.52 206.85 571.87 209.01 571.87 185.01 578.52 188.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "565.22 181.17 565.22 205.17 571.87 209.01 571.87 185.01 565.22 181.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "578.52 206.85 578.52 215.85 571.87 218.01 571.87 209.01 578.52 206.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "565.22 205.17 565.22 214.17 571.87 218.01 571.87 209.01 565.22 205.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "645.01 221.24 645.01 245.24 638.37 247.4 638.37 223.4 645.01 221.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "631.72 219.56 631.72 243.56 638.37 247.4 638.37 223.4 631.72 219.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "645.01 245.24 645.01 254.24 638.37 256.4 638.37 247.4 645.01 245.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "631.72 243.56 631.72 252.56 638.37 256.4 638.37 247.4 631.72 243.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "711.51 199.64 711.51 223.64 704.86 225.8 704.86 201.8 711.51 199.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "698.22 203.96 698.22 221.96 704.86 225.8 704.86 201.8 698.22 203.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "711.51 223.64 711.51 232.64 704.86 234.8 704.86 225.8 711.51 223.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "698.22 221.96 698.22 230.96 704.86 234.8 704.86 225.8 698.22 221.96"
  }), /*#__PURE__*/React.createElement("use", {
    width: 575.34,
    height: 172.48,
    transform: "translate(86.16 59.89)",
    xlinkHref: "#Jars_06"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "222.75 214.45 222.75 145.45 162.9 110.89 162.9 173.89 152.92 177.13 152.92 42.13 232.72 88.2 232.72 220.21 222.75 214.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "152.92 42.13 282.6 0 362.39 46.07 232.72 88.2 152.92 42.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M232.72,88.21v132l129.67-42.14v-132Zm119.7,84.1L242.7,208V148l109.72-35.65Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "242.7 198.96 342.44 166.55 352.42 172.31 242.7 207.96 242.7 198.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "352.42 112.31 342.44 115.55 342.44 166.55 352.42 172.31 352.42 112.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "162.9 110.89 172.83 116.74 172.87 170.65 162.9 173.89 162.9 110.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "295.9 76.68 295.9 121.68 349.1 104.39 349.1 59.39 295.9 76.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "239.37 95.04 239.37 137.04 285.92 121.92 285.92 79.92 239.37 95.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M268.61,98.5a2.73,2.73,0,0,1-2.74-2.82,4.53,4.53,0,0,1,3.06-4.1,3.31,3.31,0,0,1,1.06-.17,2.72,2.72,0,0,1,2.74,2.82,4.5,4.5,0,0,1-3.06,4.09A3.28,3.28,0,0,1,268.61,98.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M274.11,94.73l-3.21-1.85a1.8,1.8,0,0,0-1.6-.16,3.36,3.36,0,0,0-2.23,3,1.62,1.62,0,0,0,.53,1.25l3.58,2.1a1.83,1.83,0,0,0,1.45.07,3.35,3.35,0,0,0,2.23-2.95A1.57,1.57,0,0,0,274.11,94.73Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-20",
    cx: 272.63,
    cy: 96.87,
    rx: 2.62,
    ry: 1.9,
    transform: "translate(22.2 241.76) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M278.59,95.26a2.72,2.72,0,0,1-2.74-2.83,4.51,4.51,0,0,1,3.06-4.09,3.28,3.28,0,0,1,1.06-.18A2.73,2.73,0,0,1,282.71,91a4.52,4.52,0,0,1-3.06,4.09A3.37,3.37,0,0,1,278.59,95.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M284.08,91.49l-3.2-1.85a1.78,1.78,0,0,0-1.6-.16,3.34,3.34,0,0,0-2.23,3,1.61,1.61,0,0,0,.52,1.25l3.59,2.1a1.81,1.81,0,0,0,1.44.07,3.35,3.35,0,0,0,2.23-3A1.54,1.54,0,0,0,284.08,91.49Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-20",
    cx: 282.6,
    cy: 93.63,
    rx: 2.62,
    ry: 1.9,
    transform: "translate(28.18 248.22) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M267.54,108.21a2.4,2.4,0,0,1-2.44-2.53,4.27,4.27,0,0,1,2.86-3.81,3.27,3.27,0,0,1,1-.16,2.4,2.4,0,0,1,2.44,2.53,4.26,4.26,0,0,1-2.85,3.81A3.28,3.28,0,0,1,267.54,108.21Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-21",
    cx: 268.23,
    cy: 104.96,
    rx: 2.62,
    ry: 1.9,
    transform: "translate(14.49 241.27) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M274.19,106a2.4,2.4,0,0,1-2.44-2.52,4.27,4.27,0,0,1,2.86-3.81,3.27,3.27,0,0,1,1-.16,2.4,2.4,0,0,1,2.44,2.52,4.27,4.27,0,0,1-2.85,3.82A3.27,3.27,0,0,1,274.19,106Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-21",
    cx: 274.88,
    cy: 102.8,
    rx: 2.62,
    ry: 1.9,
    transform: "translate(18.48 245.57) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M280.84,103.88a2.4,2.4,0,0,1-2.44-2.52,4.27,4.27,0,0,1,2.86-3.81,3.27,3.27,0,0,1,1-.16,2.4,2.4,0,0,1,2.44,2.52,4.25,4.25,0,0,1-2.85,3.81A3,3,0,0,1,280.84,103.88Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-21",
    cx: 281.53,
    cy: 100.64,
    rx: 2.62,
    ry: 1.9,
    transform: "translate(22.46 249.87) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M259.91,122.33a2.91,2.91,0,0,1-3-3,5.16,5.16,0,0,1,3.45-4.61,3.78,3.78,0,0,1,1.17-.2,2.91,2.91,0,0,1,3,3,5.14,5.14,0,0,1-3.46,4.61A3.69,3.69,0,0,1,259.91,122.33Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-21",
    cx: 260.75,
    cy: 118.4,
    rx: 3.17,
    ry: 2.3,
    transform: "translate(1.62 240.3) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M269.89,119.09a2.91,2.91,0,0,1-2.95-3,5.13,5.13,0,0,1,3.45-4.61,3.74,3.74,0,0,1,1.17-.2,2.91,2.91,0,0,1,2.95,3,5.14,5.14,0,0,1-3.45,4.61A3.78,3.78,0,0,1,269.89,119.09Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-21",
    cx: 270.72,
    cy: 115.16,
    rx: 3.17,
    ry: 2.3,
    transform: "translate(7.6 246.75) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M279.86,115.85a2.91,2.91,0,0,1-2.95-3.06,5.17,5.17,0,0,1,3.45-4.61,4.08,4.08,0,0,1,1.17-.19,2.91,2.91,0,0,1,3,3.05,5.15,5.15,0,0,1-3.46,4.61A3.69,3.69,0,0,1,279.86,115.85Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-21",
    cx: 280.7,
    cy: 111.92,
    rx: 3.17,
    ry: 2.3,
    transform: "translate(13.58 253.21) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "256 95.64 256 110.64 262.65 108.48 262.65 93.48 256 95.64"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-22",
    x1: 242.7,
    y1: 102.96,
    x2: 252.57,
    y2: 99.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-22",
    x1: 242.7,
    y1: 105.96,
    x2: 252.57,
    y2: 102.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-22",
    x1: 242.7,
    y1: 108.96,
    x2: 252.57,
    y2: 105.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "242.7 114.96 252.67 111.72 252.67 126.72 242.7 129.96 242.7 114.96"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-22",
    x1: 257.65,
    y1: 125.11,
    x2: 264.3,
    y2: 122.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-22",
    x1: 267.29,
    y1: 121.97,
    x2: 273.94,
    y2: 119.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-22",
    x1: 277.49,
    y1: 118.66,
    x2: 284.14,
    y2: 116.5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "Graphic-Style-2",
    points: "242.7 147.96 242.7 204.96 349.1 170.39 349.1 113.39 242.7 147.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "172.87 161.65 222.75 145.45 222.75 154.45 172.87 170.65 172.87 161.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "Graphic-Style-2",
    points: "172.83 116.74 222.75 145.45 222.75 148.45 172.87 164.65 172.83 116.74"
  }), /*#__PURE__*/React.createElement("use", {
    width: 9.98,
    height: 79.77,
    transform: "translate(227.26 0.45)",
    xlinkHref: "#WarningLightOff_01"
  }), /*#__PURE__*/React.createElement("use", {
    width: 83.12,
    height: 195.84,
    transform: "translate(305.6 6.87)",
    xlinkHref: "#Screen_Arm_01b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fyldning_Inspektion",
    "data-name": "Fyldning & Inspektion"
  }, /*#__PURE__*/React.createElement("use", {
    width: 755,
    height: 356.28,
    xlinkHref: "#Machine_Belt_01"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMachineBelt1);
export default __webpack_public_path__ + "static/media/machine-belt-1.3c3d9fdfc86aabce2e400e4dff9c97e0.svg";
export { ForwardRef as ReactComponent };